export default __webpack_public_path__ + "static/media/GooglePlay.e0eb1f94.png";